import { MediaType, tvpil } from '../../data/compat/tvpil';
import { RentalAsset } from '../../data/rental/types';
import { RequiredEntitledTvod, processTvod } from '../processing/tvods';
import { fetchTvodList } from '../queries';
import { hasAdultFilter, shouldIncludeAdult } from '../utils';

type FetchRentalsArgs = {
  pageIndex: number;
  pageSize: number;
  ksql?: string;
};

const metaProperties = ['Adult', 'ParentalRating', 'MarkerBackgroundColor', 'ContentMarkerText', 'MarkerTextColor'];

export async function fetchRentals({ pageIndex, pageSize, ksql }: FetchRentalsArgs) {
  const retrievedMetadata = [...tvpil.availableRatingsNames, ...metaProperties];
  const { items, totalCount } = await fetchTvodList({
    variables: {
      page: {
        index: pageIndex,
        size: pageSize,
      },
      config: {
        vodMovie: {
          typeId: Number(tvpil.dms.mediaTypes[MediaType.Movie]),
        },
        vodEpisode: {
          typeId: Number(tvpil.dms.mediaTypes[MediaType.Episode]),
        },
      },
    },
    retrievedMetadata: retrievedMetadata,
  });

  const objects: RentalAsset[] = [];

  for (let i = 0; i < items.length; i++) {
    const item = items[i];

    if (!item.vod) {
      continue;
    }

    const processed = processTvod(item as RequiredEntitledTvod);

    /**
     * parse ksql
     * - if it doesn't contain adult rules push every item
     * - if it contains adult rules we apply them to the list (push adult or not adult assets only)
     */
    if (!hasAdultFilter(ksql) || shouldIncludeAdult(ksql) === processed.isAdult) {
      objects.push(processed);
    }
  }

  return {
    objects,
    totalCount,
  };
}
